import { createSlice } from "@reduxjs/toolkit";
import { fetchFeaturedBrands, fetchBrandProducts, fetchAllBrands } from "../actions/brandActions";

const BrandReducers = createSlice({
    name: 'BrandReducers',
    initialState: {
        loader: false,
        errors: null,
        featuredBrands: [],
        brandProducts: {},
        allBrands: [], // Add allBrands to initial state
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            /**
             * Featured Brands
             */
            .addCase(fetchFeaturedBrands.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(fetchFeaturedBrands.fulfilled, (state, action) => {
                state.loader = false;
                state.featuredBrands = action.payload;
            })
            .addCase(fetchFeaturedBrands.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            })

            /**
             * Brand Products
             */
            .addCase(fetchBrandProducts.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(fetchBrandProducts.fulfilled, (state, action) => {
                const { brand, products } = action.payload;
                state.loader = false;
                state.brandProducts[brand] = products;
            })
            .addCase(fetchBrandProducts.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            })

            /**
             * All Brands
             */
            .addCase(fetchAllBrands.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(fetchAllBrands.fulfilled, (state, action) => {
                state.loader = false;
                state.allBrands = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(fetchAllBrands.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            });
    }
});

export default BrandReducers.reducer;
